export default __webpack_public_path__ + "static/media/thumb-Multi-GNSS-Module-1.e3989f5e.png";